export const language = {
  en: {
    orderNumber: "Order Number",
    email: "Email",
    orderPlaced: "Order Placed",
    total: "Total",
    receptionMessage:
      "😊 Thank you for making the purchase, you can download your purchase using the link below.",
    downloadBtnText: "Download",
    visitStore: "Visit Store",
    orders: "Orders",
    loadingMessage:
      "Loading files.... Please wait. For any problem, contact the store owner.",
    variantName: "Variant Name",
    digitalFileName: "Digital File Name",
    fileType: "File Type",
    fileSize: "File Size",
    licenseKey: "License Key",
    downloads: "Downloads",
  },
  lt: {
    orderNumber: "Užsakymo numeris",
    email: "El. paštas",
    orderPlaced: "Užsakymas pateiktas",
    total: "Iš viso",
    receptionMessage:
      "😊 Dėkojame už pirkinį, galite atsisiųsti savo pirkinį naudodami žemiau esančią nuorodą.",
    downloadBtnText: "Atsisiųsti",
    visitStore: "Apsilankyti parduotuvėje",
    orders: "Užsakymai",
    loadingMessage:
      "Įkeliami failai.... Prašome palaukti. Dėl bet kokių problemų susisiekite su parduotuvės savininku.",
    variantName: "Varianto pavadinimas",
    digitalFileName: "Skaitmeninio failo pavadinimas",
    fileType: "Failo tipas",
    fileSize: "Failo dydis",
    licenseKey: "Licencijos raktas",
    downloads: "Atsisiuntimai",
  },
  fr: {
    orderNumber: "Numéro de commande",
    email: "Email",
    orderPlaced: "Commande passée",
    total: "Total",
    receptionMessage:
      "😊 Merci pour votre achat, vous pouvez télécharger votre achat en utilisant le lien ci-dessous.",
    downloadBtnText: "Télécharger",
    visitStore: "Visiter la boutique",
    orders: "Commandes",
    loadingMessage:
      "Chargement des fichiers.... Veuillez patienter. Pour tout problème, contactez le propriétaire du magasin.",

    variantName: "Nom de variante",
    digitalFileName: "Nom du fichier numérique",
    fileType: "Type de fichier",
    fileSize: "Taille du fichier",
    licenseKey: "Clé de licence",
    downloads: "Téléchargements",
  },
  es: {
    orderNumber: "Número de pedido",
    email: "Correo electrónico",
    orderPlaced: "Pedido realizado",
    total: "Total",
    receptionMessage:
      "😊 Gracias por su compra, puede descargar su compra utilizando el enlace a continuación.",
    downloadBtnText: "Descargar",
    visitStore: "Visitar tienda",
    orders: "Pedidos",
    loadingMessage:
      "Cargando archivos.... Por favor, espere. Para cualquier problema, contacte al dueño de la tienda.",
    variantName: "Nombre de variante",
    digitalFileName: "Nombre del archivo digital",
    fileType: "Tipo de archivo",
    fileSize: "Tamaño del archivo",
    licenseKey: "Clave de licencia",
    downloads: "Descargas",
  },
  de: {
    orderNumber: "Bestellnummer",
    email: "E-Mail",
    orderPlaced: "Bestellung aufgegeben",
    total: "Gesamt",
    receptionMessage:
      "😊 Vielen Dank für Ihren Einkauf. Sie können Ihren Kauf über den unten stehenden Link herunterladen.",
    downloadBtnText: "Herunterladen",
    visitStore: "Geschäft besuchen",
    orders: "Bestellungen",
    loadingMessage:
      "Dateien werden geladen.... Bitte warten Sie. Bei Problemen kontaktieren Sie den Ladenbesitzer.",
    variantName: "Variantenname",
    digitalFileName: "Name der digitalen Datei",
    fileType: "Dateityp",
    fileSize: "Dateigröße",
    licenseKey: "Lizenzschlüssel",
    downloads: "Downloads",
  },
  da: {
    orderNumber: "Ordrenummer",
    email: "E-mail",
    orderPlaced: "Ordre afgivet",
    total: "Total",
    receptionMessage:
      "😊 Tak for dit køb. Du kan downloade dit køb via linket nedenfor.",
    downloadBtnText: "Download",
    visitStore: "Besøg butik",
    orders: "Ordrer",
    loadingMessage:
      "Indlæser filer.... Vent venligst. Ved problemer, kontakt butiksejeren.",
    variantName: "Variantnavn",
    digitalFileName: "Digitalt Filnavn",
    fileType: "Filtype",
    fileSize: "Filstørrelse",
    licenseKey: "Licensnøgle",
    downloads: "Downloads",
  },
  it: {
    orderNumber: "Numero d'ordine",
    email: "Email",
    orderPlaced: "Ordine effettuato",
    total: "Totale",
    receptionMessage:
      "😊 Grazie per il tuo acquisto, puoi scaricare il tuo acquisto utilizzando il link qui sotto.",
    downloadBtnText: "Scarica",
    visitStore: "Visita il negozio",
    orders: "Ordini",

    loadingMessage:
      "Caricamento dei file.... Attendere prego. Per qualsiasi problema, contatta il proprietario del negozio.",
    variantName: "Nome variante",
    digitalFileName: "Nome del file digitale",
    fileType: "Tipo di file",
    fileSize: "Dimensione del file",

    licenseKey: "Chiave di licenza",
    downloads: "Download",
  },
  zh: {
    orderNumber: "订单编号",
    email: "电子邮件",
    orderPlaced: "下单日期",
    total: "总计",
    receptionMessage: "😊 感谢您的购买，您可以使用下面的链接下载您的购买内容。",
    downloadBtnText: "下载",
    visitStore: "访问商店",
    orders: "订单",
    loadingMessage: "正在加载文件.... 请稍候。如有任何问题，请联系店主。",
    variantName: "变体名称",
    digitalFileName: "数字文件名称",
    fileType: "文件类型",
    fileSize: "文件大小",
    licenseKey: "许可证密钥",
    downloads: "下载",
  },
  ja: {
    orderNumber: "注文番号",
    email: "メールアドレス",
    orderPlaced: "注文日",
    total: "合計",
    receptionMessage:
      "😊 ご購入いただきありがとうございます。以下のリンクを使用して購入をダウンロードできます。",
    downloadBtnText: "ダウンロード",
    visitStore: "ストアを見る",
    orders: "注文",
    loadingMessage:
      "ファイルを読み込んでいます.... 少々お待ちください。問題がある場合は、店舗のオーナーに連絡してください。",
    variantName: "バリアント名",
    digitalFileName: "デジタルファイル名",
    fileType: "ファイルタイプ",
    fileSize: "ファイルサイズ",
    licenseKey: "ライセンスキー",
    downloads: "ダウンロード",
  },
  bg: {
    orderNumber: "Номер на поръчка",
    email: "Имейл",
    orderPlaced: "Дата на поръчка",
    total: "Общо",
    receptionMessage:
      "😊 Благодарим ви за покупката! Можете да изтеглите покупката си, като използвате връзката по-долу.",
    downloadBtnText: "Изтегляне",
    visitStore: "Посетете магазина",
    orders: "Поръчки",
    loadingMessage:
      "Зареждане на файлове.... Моля, изчакайте. При проблеми се свържете със собственика на магазина.",
    variantName: "Име на вариант",
    digitalFileName: "Цифрово име на файл",
    fileType: "Тип файл",
    fileSize: "Размер на файла",
    licenseKey: "Лицензионен ключ",
    downloads: "Изтегляния",
  },
  nl: {
    orderNumber: "Bestelnummer",
    email: "E-mail",
    orderPlaced: "Bestelling geplaatst",
    total: "Totaal",
    receptionMessage:
      "😊 Bedankt voor uw aankoop, u kunt uw aankoop downloaden via de onderstaande link.",
    downloadBtnText: "Downloaden",
    visitStore: "Winkel bezoeken",
    orders: "Bestellingen",
    loadingMessage:
      "Bestanden worden geladen.... Even geduld. Neem bij problemen contact op met de winkelier.",
    variantName: "Variantnaam",
    digitalFileName: "Digitale bestandsnaam",
    fileType: "Bestandstype",
    fileSize: "Bestandsgrootte",
    licenseKey: "Licentiesleutel",
    downloads: "Downloads",
  },
  tr: {
    orderNumber: "Sipariş Numarası",
    email: "E-posta",
    orderPlaced: "Sipariş Verildi",
    total: "Toplam",
    receptionMessage:
      "😊 Satın aldığınız için teşekkür ederiz, aşağıdaki bağlantıyı kullanarak ürününüzü indirebilirsiniz.",
    downloadBtnText: "İndir",
    visitStore: "Mağazayı Ziyaret Et",
    orders: "Siparişler",
    loadingMessage:
      "Dosyalar yükleniyor.... Lütfen bekleyiniz. Herhangi bir sorun için mağaza sahibi ile iletişime geçiniz.",
    variantName: "Varyant Adı",
    digitalFileName: "Dijital Dosya Adı",
    fileType: "Dosya Türü",
    fileSize: "Dosya Boyutu",
    licenseKey: "Lisans Anahtarı",
    downloads: "İndirmeler",
  },
  he: {
    orderNumber: "מספר הזמנה",
    email: "אימייל",
    orderPlaced: "הזמנה בוצעה",
    total: "סה״כ",
    receptionMessage:
      "😊 תודה על הרכישה, ניתן להוריד את הרכישה שלך באמצעות הקישור למטה.",
    downloadBtnText: "הורדה",
    visitStore: "בקר בחנות",
    orders: "הזמנות",
    loadingMessage:
      "טוען קבצים.... אנא המתן. לכל בעיה, צור קשר עם בעל החנות.",
    variantName: "שם וריאנט",
    digitalFileName: "שם קובץ דיגיטלי",
    fileType: "סוג קובץ",
    fileSize: "גודל קובץ",
    licenseKey: "מפתח רישיון",
    downloads: "הורדות",
  },
  pl: {
    orderNumber: "Numer zamówienia",
    email: "Email",
    orderPlaced: "Data zamówienia",
    total: "Podsumowanie",
    receptionMessage:
      "😊 Dziękujemy za zakupy! Poniżej znajdziesz link do pobrania swoich plików.",
    downloadBtnText: "Pobierz pliki",
    visitStore: "Przejdź do sklepu",
    orders: "Zamówienia",
    loadingMessage:
      "Ładowanie plików.... Proszę czekać. W przypadku problemów skontaktuj się z właścicielem sklepu.",
    variantName: "Wariant",
    digitalFileName: "Nazwa pliku",
    fileType: "Format",
    fileSize: "Rozmiar",
    licenseKey: "Klucz licencyjny",
    downloads: "Dostępne pliki",
  },
  hu: {
    orderNumber: "Rendelésszám",
    email: "E-mail",
    orderPlaced: "Rendelés dátuma",
    total: "Összesen",
    receptionMessage:
      "😊 Köszönjük a vásárlást! Az alábbi link segítségével töltheti le a megvásárolt fájlokat.",
    downloadBtnText: "Letöltés",
    visitStore: "Bolt meglátogatása",
    orders: "Rendelések",
    loadingMessage:
      "Fájlok betöltése.... Kérjük, várjon. Probléma esetén vegye fel a kapcsolatot az üzlet tulajdonosával.",
    variantName: "Változat neve",
    digitalFileName: "Digitális fájl neve",
    fileType: "Fájltípus",
    fileSize: "Fájlméret",
    licenseKey: "Licenckulcs",
    downloads: "Letöltések",
  },
  sv: {
    orderNumber: "Ordernummer",
    email: "E-post",
    orderPlaced: "Beställning lagd",
    total: "Total",
    receptionMessage:
      "😊 Tack för att du gjorde köpet, du kan ladda ner ditt köp via länken nedan.",
    downloadBtnText: "Ladda ner",
    visitStore: "Besök butiken",
    orders: "Beställningar",
    loadingMessage:
      "Laddar filer.... Vänta. Kontakta butiksägaren vid problem.",
    variantName: "Variantnamn",
    digitalFileName: "Digitalt filnamn",
    fileType: "Filtyp",
    fileSize: "Filstorlek",
    licenseKey: "Licensnyckel",
    downloads: "Nedladdningar",
  },
};
